/** Display labels shared by the Resources tab (role panel + staffing grid). */

// Short keys are acronyms ('bpr' -> 'BPR'); longer ones are title-cased.
export const labelize = (k: string): string =>
  k.length <= 3
    ? k.toUpperCase()
    : k.replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function categoryLabel(keys: Array<string | null>): string {
  const named = keys.filter((k): k is string => !!k).map(labelize);
  return named.length > 0 ? named.join(', ') : 'All deals';
}
